import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AccessControlService } from './access-control.service';

@Injectable({
  providedIn: 'root'
})
export class CheckPermissionService {
  checkAction = new Subject<String>();
  constructor(private router: Router,
    private accessControlService: AccessControlService) { }
  getAction(route: any) {
    var entries = [];
    //Maintenence Module
    const permissions = this.accessControlService.permissions()
    if (permissions && permissions.permissions[0]) {
      //create array of objects
      entries = Object.entries(permissions.permissions[0]);
      for (var i = 0; i < entries.length; i++) {
        try {
          //check Sections[sub module]
          if (permissions.permissions[0][i].section && permissions.permissions[0][i].section.length) {
            for (var j = 0; j < permissions.permissions[0][i].section.length; j++) {
              // Maintenance Sections
              try {
                if (this.router.url == '/course-listing' || this.router.url.indexOf('/add-course') > -1 || this.router.url.indexOf('/edit-course') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'Basic course' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // course Actions
                        try {
                          // check for CourseListing Page
                          if (this.router.url == '/course-listing') {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'add' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'edit' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'delete' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'delete') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/add-course') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check For Edit Page
                          if (this.router.url.indexOf('/edit-course') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'edit') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }

                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
                if (this.router.url == '/commonparagraph-listing' || this.router.url.indexOf('/addcommon-paragraph') > -1 || this.router.url.indexOf('/editcommon-paragraph') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'Common paragraph' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // course Actions
                        try {
                          // check for CourseListing Page
                          if (this.router.url == '/commonparagraph-listing') {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'add' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'edit' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'delete' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'delete') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/addcommon-paragraph') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check For Edit Page
                          if (this.router.url.indexOf('/editcommon-paragraph') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'edit') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }

                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
                if (this.router.url == '/generalparagraph-listing' || this.router.url.indexOf('/add-generalparagraph') > -1 || this.router.url.indexOf('/edit-generalparagraph') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'General paragraph' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // course Actions
                        try {
                          // check for CourseListing Page
                          if (this.router.url == '/generalparagraph-listing') {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'add' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'edit' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'delete' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'delete') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/add-generalparagraph') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check For Edit Page
                          if (this.router.url.indexOf('/edit-generalparagraph') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'edit') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }

                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
                if (this.router.url == '/inventory-listing' || this.router.url.indexOf('/add-inventory') > -1 || this.router.url.indexOf('/edit-inventory') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'Inventory' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // course Actions
                        try {
                          // check for CourseListing Page
                          if (this.router.url == '/inventory-listing') {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'add' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'edit' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'delete' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'delete') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/add-inventory') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check For Edit Page
                          if (this.router.url.indexOf('/edit-inventory') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'edit') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }

                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
                if (this.router.url == '/paragraphlink-listing' || this.router.url.indexOf('/editparagraph-link') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'Paragraph link' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // course Actions
                        try {
                          // check for CourseListing Page
                          if (this.router.url == '/paragraphlink-listing') {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'link' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'linking') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'unlink' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'unlinking') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/editparagraph-link') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'linking') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'unlinking') {
                                  if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                    this.router.navigate(['access-denied']);
                                  }
                                }
                              }
                              if (route == 'link' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'linking') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                            if (route == 'unlink' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'unlinking') {
                              return permissions.permissions[0][i].section[j].section_action[k].value;
                              break;
                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
                if (this.router.url == '/location-listing' || this.router.url.indexOf('/add-location') > -1 || this.router.url.indexOf('/edit-location') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'Locations' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // course Actions
                        try {
                          // check for CourseListing Page
                          if (this.router.url == '/location-listing') {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'add' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'edit' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'delete' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'delete') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/add-location') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check For Edit Page
                          if (this.router.url.indexOf('/edit-location') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'edit') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }

                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
                if (this.router.url == '/masl-courselisting' || this.router.url.indexOf('/edit-maslcode') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'MASL' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // course Actions
                        try {
                          // check for CourseListing Page
                          if (this.router.url == '/masl-courselisting') {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'edit' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/edit-maslcode') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'edit') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
                if (this.router.url == '/adsc-courselisting' || this.router.url.indexOf('/edit-adsc-description') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'ADSC' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // course Actions
                        try {
                          // check for CourseListing Page
                          if (this.router.url == '/adsc-courselisting') {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'edit' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/edit-adsc-description') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'edit') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
                if (this.router.url == '/publish-courselisting' || this.router.url.indexOf('/publish-course') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'Publish-Unpublish' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // course Actions
                        try {
                          // check for CourseListing Page
                          if (this.router.url == '/publish-courselisting') {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'edit' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/publish-course') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'edit') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
                //Reports Section
                if (this.router.url == '/reports-courselisting' || this.router.url.indexOf('/course-report') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'Course report' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // REports Actions
                        try {
                          // check for Listing Page
                          if (this.router.url == '/reports-courselisting') {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'view' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'view') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for View
                          if (this.router.url.indexOf('/course-report') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'view') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
                // Setting Section
                if (this.router.url.indexOf('/user-listing') > -1 || this.router.url.indexOf('/system-user-listing') > -1 || this.router.url.indexOf('/add-user') > -1 || this.router.url.indexOf('/edit-user') > -1 ) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'User' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // user Actions
                        try {
                          // check for Listing Page
                          if (this.router.url.indexOf('/user-listing') > -1 || this.router.url.indexOf('/system-user-listing') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'add' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'edit' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'delete' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'delete') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/add-user') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check For Edit Page
                          if (this.router.url.indexOf('/edit-user') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'edit') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }

                            }
                          }
 }
                        catch (e) { }
                      }
                    }
                  }
                }
                if (this.router.url.indexOf('/change-password') > -1 ) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'Change password' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // Password Actions
                        try {
                       //Check For Change Page
                          if (this.router.url.indexOf('/change-password') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              // if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                              //   this.router.navigate(['access-denied']);
                              // }
                              // else
                               if (route == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }

                            }
                          }
                       }
                        catch (e) { }
                      }
                    }
                  }
                }
                if (this.router.url.indexOf('/role-listing') > -1 || this.router.url.indexOf('/add-roles') > -1 || this.router.url.indexOf('/edit-role') > -1 || this.router.url.indexOf('/role-permissions') > -1) {
                  if (permissions.permissions[0][i].section[j].section_name && permissions.permissions[0][i].section[j].section_name + "" == 'Roles' && permissions.permissions[0][i].section[j].value == true) {
                    if (permissions.permissions[0][i].section[j].section_action && permissions.permissions[0][i].section[j].section_action.length) {
                      for (var k = 0; k < permissions.permissions[0][i].section[j].section_action.length; k++) {
                        // user Actions
                        try {
                          // check for Listing Page
                          if (this.router.url.indexOf('/role-listing') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name) {
                              if (route == 'add' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'edit' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'delete' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'delete') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                              if (route == 'permission' && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add permissions') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }

                            }
                          }
                          //Check for add Page
                          if (this.router.url.indexOf('/add-roles') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'add') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }
                            }
                          }
                          //Check For Edit Page
                          if (this.router.url.indexOf('/edit-role') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'update') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'edit') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }

                            }
                          }
                          //Check For permission Page
                          if (this.router.url.indexOf('/role-permissions') > -1) {
                            if (permissions.permissions[0][i].section[j].section_action[k].action_name && permissions.permissions[0][i].section[j].section_action[k].action_name + "" == 'add permissions') {
                              if (permissions.permissions[0][i].section[j].section_action[k].value == false) {
                                this.router.navigate(['access-denied']);
                              }
                              else if (route == 'permission') {
                                return permissions.permissions[0][i].section[j].section_action[k].value;
                                break;
                              }

                            }
                          }
                        }
                        catch (e) { }
                      }
                    }
                  }
                }
              }
              catch (e) { }
            }
          }
        }
        catch (e) { }
      }
    }

  }
}
